export const never = async (): Promise<never> => {
  await new Promise(() => {})
  throw new Error("Should never happen")
}
